import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import videosData from "./videos.json";
import SVGTitle from "./SVGTitle";
import { Helmet } from "react-helmet-async";
import { t } from "i18next";

function Reviews() {
  const videos = videosData.videos;
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setSelectedVideo(null);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  const playIconStyle = {
    position: "absolute",
    fontSize: "40px",
    color: "#fff",
    pointerEvents: "none",
  };

  return (
    <div className="reviews py-5 mt-5" style={{ backgroundColor: "#EFEFEF" }}>
      <Helmet>
        <link rel="canonical" href="https://saleemsmile.com/reviews" />

        <title>{t("reviewsPage.meta.title")}</title>
        <meta name="description" content={t("reviewsPage.meta.description")} />
        <meta name="keywords" content={t("reviewsPage.meta.keywords")} />

        <meta property="og:title" content={t("reviewsPage.meta.ogTitle")} />
        <meta
          property="og:description"
          content={t("reviewsPage.meta.ogDescription")}
        />
        <meta
          property="og:image"
          content="https://saleemsmile.com/images/reviews-cover.jpg"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://saleemsmile.com/reviews" />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "ItemList",
              name: t("reviewsPage.schema.name"),
              description: t("reviewsPage.schema.description"),
              itemListElement: videos.map((video, index) => ({
                "@type": "VideoObject",
                position: index + 1,
                name:
                  video.title ||
                  `${t("reviewsPage.schema.videoTitle")} ${index + 1}`,
                description:
                  video.description || t("reviewsPage.schema.videoDescription"),
                contentUrl: video.src,
                thumbnailUrl: video.poster,
                uploadDate: "2025-10-01",
                publisher: {
                  "@type": "Organization",
                  name: "Saleem Smile Clinic",
                  logo: {
                    "@type": "ImageObject",
                    url: "https://saleemsmile.com/images/logo.png",
                  },
                },
              })),
            }),
          }}
        />
      </Helmet>

      <div className="head text-center">
        <h2 className="mb-4 fs-1 fw-bolder">{t("reviews.heading")}</h2>
        <SVGTitle />
      </div>

      <div className="container">
        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          breakpoints={{
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
            1200: { slidesPerView: 5 },
          }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true, el: ".swiper-pagination-custom" }}
          navigation
          modules={[Autoplay, Pagination, Navigation]}
          className="mb-4"
        >
          {videos.slice(0, 5).map((video, index) => (
            <SwiperSlide key={video.id || index}>
              <div
                className="video-wrapper rounded-4 overflow-hidden position-relative"
                onClick={() => setSelectedVideo(video.src)}
                style={{
                  cursor: "pointer",
                  height: "200px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#000",
                }}
              >
                <video
                  src={video.src}
                  poster={video.poster}
                  muted
                  loop
                  playsInline
                  preload="auto"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "16px",
                  }}
                />
                <span style={playIconStyle}>
                  <i className="fa-solid fa-play"></i>
                </span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="swiper-pagination-custom text-center mt-3"></div>

        <div className="row g-4 justify-content-center mt-4">
          {videos.slice(5).map((video, index) => (
            <div
              key={video.id || index}
              className="col-6 col-md-4 col-lg-3"
              onClick={() => setSelectedVideo(video.src)}
              style={{ cursor: "pointer" }}
            >
              <div
                className="video-wrapper shadow rounded-4 overflow-hidden position-relative"
                style={{
                  height: "150px",
                  background: "#000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <video
                  src={video.src}
                  poster={video.poster}
                  muted
                  loop
                  playsInline
                  preload="auto"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "16px",
                  }}
                />
                <span style={playIconStyle}>
                  <i className="fa-solid fa-play"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedVideo && (
        <div
          className="video-modal position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: "rgba(0,0,0,0.9)", zIndex: 1050 }}
          onClick={() => setSelectedVideo(null)}
        >
          <video
            src={selectedVideo}
            controls
            autoPlay
            style={{ maxWidth: "100%", maxHeight: "90vh" }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}

export default Reviews;
